import { render, staticRenderFns } from "./RadioVirtualAccountFixed.vue?vue&type=template&id=e234b314&lang=pug"
import script from "./RadioVirtualAccountFixed.vue?vue&type=script&lang=js"
export * from "./RadioVirtualAccountFixed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports